import React, { Component } from 'react';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';

import Welcome from './Welcome';
import CarTierCheckBox from './CarTierCheckBox';
import DurationSlider from './DurationSlider';
import StartTimeSelect from './StartTimeSelect';
import ParkingCheckBox from './ParkingCheckBox';
import './index.css';

class Preferences extends Component {
  constructor(props) {
    super(props);
    this.state = {
      duration: 4,
      openIndex: this.props.openIndex,
      startTime: 3,
      tier: 'Pro',
      location: null
    };
  }

  handleNextIndex = () =>
    this.setState({ openIndex: this.state.openIndex + 1 });

  handlePrevIndex = () =>
    this.setState({ openIndex: this.state.openIndex - 1 });

  handleTierFilter = tier => this.setState({ tier });

  handleStartTimeFilter = startTime => this.setState({ startTime });

  handleDurationFilter = duration => this.setState({ duration });

  handleParkinglotFilter = ({ id }) => this.setState({ location: id });

  submitForm = () => {
    this.props.newPreferences(this.state);
  };

  modalContent = () => {
    const { duration, openIndex, startTime, tier } = this.state;
    const { certification, openDialog, parkinglots, shifts } = this.props;
    switch (openIndex) {
      case 0:
        return <Welcome />;
      case 1:
        return (
          <CarTierCheckBox
            selectedTier={tier}
            handleTierFilter={this.handleTierFilter}
            openDialog={openDialog}
            certification={certification}
          />
        );
      case 2:
        return (
          <StartTimeSelect
            shifts={shifts}
            handleStartTimeFilter={this.handleStartTimeFilter}
            startTime={startTime}
          />
        );
      case 3:
        return (
          <DurationSlider
            handleDurationFilter={this.handleDurationFilter}
            duration={duration}
          />
        );
      case 4:
        return (
          <ParkingCheckBox
            handleParkinglotFilter={this.handleParkinglotFilter}
            parkinglots={
              parkinglots.length > 1
                ? [parkinglots[parkinglots.length - 1]]
                : parkinglots
            }
          />
        );
      default:
        return null;
    }
  };

  modalActions = () => {
    switch (this.state.openIndex) {
      case 0:
        return <FlatButton label="Next" onClick={this.handleNextIndex} />;
      case 1:
        return <FlatButton label="Next" onClick={this.handleNextIndex} />;
      case 4:
        return [
          <FlatButton
            label="Back"
            secondary
            onClick={this.handlePrevIndex}
          />,
          <FlatButton
            label="Submit"
            onClick={this.submitForm}
            disabled={this.state.location === null}
          />
        ];
      default:
        return [
          <FlatButton
            label="Back"
            secondary
            onClick={this.handlePrevIndex}
          />,
          <FlatButton label="Next" onClick={this.handleNextIndex} />
        ];
    }
  };

  render() {
    const { openIndex } = this.state;
    const { cancelable, checkPreferences, hasPreferences } = this.props;
    return (
      <Dialog
        actions={this.modalActions()}
        modal={!cancelable}
        onRequestClose={checkPreferences}
        open={!hasPreferences && openIndex >= 0 && openIndex < 5}>
        {this.modalContent()}
      </Dialog>
    );
  }
}

export default Preferences;



// WEBPACK FOOTER //
// ./src/components/Preferences/index.js